module.exports = __webpack_public_path__ + "img/publicdomain.32984610.png";